import { Fragment } from "react";
import ItemsTitle from "../ItemsTitle";
import { useTranslation } from "react-i18next";
import Button from "../../../../../../../publicComponent/Button";
import { getOrderStatus } from "../../../../../../../utils";
import { useQueryParam } from "../../../../../../../hooks";

export default function Schedule({
  detail = {},
  cancelOrderHandle,
  openPayTypeModal,
}) {
  const { t } = useTranslation();

  const arr = [
    {
      label: "订单创建",
      icon: "orderCreate",
      time: detail.createTime,
    },
    {
      label: "订单支付",
      icon: "orderPay",
      time: detail.payTime,
    },
    {
      label: "卖家发货",
      icon: "sellerSend",
      time: detail.deliveryDate,
    },
    {
      label: "买家确认收货",
      icon: "buyerReceive",
      time: detail.reachTime,
    },
    {
      label: "订单完成",
      icon: "orderFinish",
      time: detail.finishTime,
    },
  ];

  let tit = getOrderStatus(detail.orderStatus);
  const [payType] = useQueryParam('payType')
  console.log(arr);
  return (
    <div className="mdmax:hidden">
      <ItemsTitle title={tit} />
      <div className="flex justify-center items-center px-[5%] pl-0">
        {detail.orderStatus === 0 && (
          <div className="flex-none flex flex-col pr-[12px]">
            <Button
              onClick={cancelOrderHandle}
              className="px-[24px] py-[8px] mb-[10px] rounded-[5px] bg-white border border-[#333]"
            >
              {t("取消订单")}
            </Button>
            {(Number(payType) === 1 || Number(payType) === 2) && (
              <Button
                onClick={openPayTypeModal}
                className="px-[24px] py-[8px] rounded-[5px] bg-[#333] text-white border border-[#333]"
              >
                {t("立刻支付")}
              </Button>
            )}
          </div>
        )}
        <div className="flex flex-1 items-center px-[24px]">
          {arr.map((item, i) => (
            <Fragment key={i}>
              <div className="text-center py-[20px]" key={i}>
                <i
                  className={`iconfont text-[26px] icon-${item.icon} ${
                    item.time ? "text-[#C8A05C]" : "text-[#999]"
                  }`}
                ></i>
                <p
                  className={`py-[10px] px-[20px] font-bold ${
                    item.time ? "text-[#C8A05C]" : "text-[#999]"
                  }`}
                >
                  {t(item.label)}
                </p>
                <p
                  className={`mx-auto text-sm h-[40px] w-[60%] ${
                    item.time ? "text-[#C8A05C]" : "text-[#999]"
                  }`}
                >
                  {item.time}
                </p>
              </div>
              {i !== arr.length - 1 && (
                <div
                  className={`flex-1 border-b ${
                    item.time ? "border-[#C8A05C]" : ""
                  }`}
                ></div>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
